/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import _ from 'lodash'
import classnames from 'classnames'
import moment from 'moment'
import { toastr } from 'react-redux-toastr'
import { connect, useDispatch, useSelector } from 'react-redux'
import { isMobileOnly } from 'react-device-detect'
import axios from 'axios'
import { FaTruckMoving } from "react-icons/fa"
import { IoIosArrowBack } from "react-icons/io"
import { useTranslation } from 'react-i18next'

import SimpleMapExample from './TrackTrace/SimpleMapExampleHEREMap'
import VehicleSidebar from './TrackTrace/VehicleSidebarHM'
import TripSnapshots from './TrackTrace/TripSnapshotsHM'
import AdvancedPlayer from '../../component/AdvancedPlayer'
import EventViewSnapshotModal from '../../component/smart/modals/EventViewSnapshotModal'
import SearchBar from '../../component/dump/menuComponents/SearchBar'
import EventShareModal from '../../component/smart/modals/EventShareModal'
import EventNoteModal from '../../component/smart/modals/EventNoteModal'
import GreyHeader from '../../component/dump/menuComponents/GreyHeader'
import useInterval from '../../component/common/UseInterval'
import TreeVehiclesFilter from './TreeVehiclesFilter'
import TreeVehicles from './TreeVehicles'
import InfoPop from '../../component/common/InfoPop'
import NewMapFeedback from './NewMapFeedback'
import ZonePanel from './ZonePanel'
import BaseButtonGroup from "../../component/smart/BaseButtonGroup";

import {
	getDevicesList,
	getDevicesLastgps,
	getDevicesEventUpdates,
	getDeviceAddress,
} from '../../action/DeviceActions'
import { getEquipmentsList } from '../../action/EquipmentActions'
// import { requestCustomAlertVideo } from '../../action/AlertActions'
import { apiCall } from '../../action/RouterActions'
import { getCompanyZones } from "../../action/CompaniesActions";
import { detectDeviceStatus, getDeviceDataLimit, openLiveStream, deviceStatusPopups } from '../../component/helpers/helperVehicle'
import { formatAddress } from '../../component/helpers/tablesFuncHelpers'
// import { isInternalUser } from '../../component/helpers/constants'
import { getAvailableFleetStatuses } from '../../component/helpers/helperSleepMode'
import { dvType } from '../../component/helpers/constants'

import 'react-treeview/react-treeview.css'
import '../../component/dump/menuComponents/treeview.sass'
import '../../component/smart/menuComponentsContainer/markerWithLabel.css'
import 'react-datetime/css/react-datetime.css'

// const splitBlocks = (e) => {
// 	e.preventDefault();

// 	const x = e.pageX - $('#block-tree').offset().left;
// 	if (x > -1 && x < 3600 && e.pageX < ($(window).width() - 0)) {
// 		$('#block-tree').css("width", x);
// 		$('#map-block').css("left", x);
// 	}
// }

// function getRandomInRange(from, to, fixed) {
// 	return (Math.random() * (to - from) + from).toFixed(fixed) * 1
// }

// function convertAlertName(alert_name) {
// 	switch (alert_name) {
// 		case 'InputSensor':
// 			return 'DriverEvent';
// 		case 'FatalGSensor':
// 			return 'HighGForce';
// 		case 'HddError':
// 			return 'SDError';
// 		default:
// 			return alert_name;
// 	}
// }

const Dashboard = (props) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { user, tripAdvancedPlayerEvent, tripShowShareEvent, showTripsHistory, selectedTrip, toggleLoader, dashboardRedirect, setShowTripsHistory } = props;

	const { t } = useTranslation();
	const userRole = user.user.roles[0]
	const prevProps = useRef(props)
	const { vehiclesType } = useSelector(state => state.dashboardData);

	const [map, setMap] = useState(null)
	const [mapUI, setMapUI] = useState(null)
	const [interval, setIntervalState] = useState(null)
	const [delayInterval, setDelayInterval] = useState(null)
	const [monthlyFleetDataUsageAvailable, setMonthlyFleetDataUsageAvailable] = useState(0) // FWSD-6748
	const [fleetStatuses, setFleetStatuses] = useState({
		driving: 0, sleep: 0, offline: 0, 'pending sleep': 0, awake: 0, parked: 0, idling: 0, disabled: 0, 'pending awake': 0, 'non-vehicle': 0,
	})
	const [showZonePanel, setShowZonePanel] = useState(false)
	const [isZonePanelCollapsed, setIsZonePanelCollapsed] = useState(false)
	const [zones, setZones] = useState([])
	const storedMap = JSON.parse(localStorage.getItem("storedMap"));

	const [state, setState] = useState({
		location: null,
		initDevices: [],
		initEquipments: [],
		category: 1,
		autoValue: '',
		groups: [], // list of device groups and related devices to display in the vehicles tree
		markers: [], // list of devices with icons to display on the map
		bounds: null,
		// alerts: [],
		// alertsRemoved: [],
		// alert_filters: {
		// 	alert_gsensor: true,
		// 	alert_speed: true
		// },
		center: { lat: 37.09024, lng: -95.712891 },
		centerDevice: null,
		zoom: 6,
		maptype: 'roadmap', //'hybrid',
		activeTreeItem: null,

		// currentTimelineDate: moment(),
		// currentTimelineDateData: moment(),
		// alertdevices: [],
		playbackSpeed: 2,
		tripHeight: -14,
		additionalClassName: 'tripReplayPanelClosed',
		// polygons: [],
		// polygonDevice: null,
		// alertshistory: {
		// 	items: [],
		// 	groups: []
		// },
		// moveTo: moment(),

		alertSearchType: 'tt_local',

		selectedEvent: null,
		showAdvancedPlayer: false,
		showEventNote: false,

		company_trace_active: true,
		showLiveTraffic: false,

		// popover: {
		// 	show: false,
		// 	left: 0,
		// 	top: 0,
		// 	type: '',
		// 	content: '',
		// 	event: {
		// 		event_type: '',
		// 		event_device_id: 0,
		// 		event_id: 0,
		// 		event_ts: ''
		// 	}
		// },

		showFleetSidebar: true,
		showVehicleSidebar: false,
		showEventVideoAll: false,

		selectedGroupFleetPanel: 'group',
		filtersFleetPanel: {
			groups: [],
			statuses: { driving: true, parked: true, idling: true, sleep: true, awake: true, offline: true, disabled: true, 'pending sleep': true, 'pending awake': true, 'non-vehicle': true }
		},
	});

	const vehiclesOptions = [
		{ name: t('homePage.deviceType.btnAsset'), value: 'vehicle' },
		{ name: t('homePage.deviceType.btnEquipment'), value: 'equipment' },
		{ name: t('homePage.deviceType.btnBoth'), value: 'both' },
	];

	const sortOptions = [
		{ name: t('homePage.vehiclesSortWrapperGroup'), value: 'group' },
		{ name: t('homePage.vehiclesSortWrapperName'), value: 'name' },
		{ name: t('homePage.vehiclesSortWrapperStatus'), value: 'status' },
	];

	const isProd = location.hostname === 'fleet.roscolive.com';
	const DV7access = (!isProd && !['S3 buckets partner'].includes(props.company.company.partner)) || (isProd && (['DV7 Rosco Testing'].includes(props.company.company.partner) || props.company.company.company_id === 2774));

	useEffect(() => {
		const { company, user } = props

		traceUserAccess()

		//* The alerts should be "live" where when the alert occurs. The user should never see an alert from hours previous to them logging in to their account.

		if (user.user.settings) {
			const settings = user.user.settings;
			setState((prevState) => {
				return {
					...prevState,
					center: { lat: 37.09024, lng: -95.712891 }, zoom: settings.zoom_level || 6
				}
			})
		}

		window.addEventListener('resize', setMapCenter);
		const toggle = document.getElementsByClassName('toggle-left')[0];
		toggle && toggle.addEventListener('click', setMapCenterTimer);

		storedMap?.isShowZP && company.company.company_id && getZonePanelData(true);

		return () => {
			if (interval) {
				clearInterval(interval);
				setIntervalState(null);
			}

			window.removeEventListener('resize', setMapCenter);
			const toggle = document.getElementsByClassName('toggle-left')[0];
			toggle && toggle.removeEventListener('click', setMapCenterTimer);
			// document.removeEventListener('mouseup', documentMouseUp);
		}
	}, []);

	useEffect(() => {
		const { company } = props;
		if (company.company.company_id) {
			getAllDevices(vehiclesType, company.company.company_id, (markers) => {
				getDevicesMetadataOnline(markers);
			});
		}
	}, [props.company.company.company_id, vehiclesType]);

	useEffect(() => {
		const { activeTreeItem, markers } = state;
		if (props.showTripsHistory !== prevProps.current.showTripsHistory) {
			if (props.showTripsHistory && (!dashboardRedirect || (dashboardRedirect.type !== 'redirectFromUnknownDrivers') && !['redirectFromDailyEvents', 'redirectFromBellNotificationsOpenLS'].includes(dashboardRedirect.type))) {
				const obj = markers.find(item => { if (item.device_id === activeTreeItem.device_id) return item })
				setState((prevState) => {
					return {
						...prevState,
						// polygons: [],
						markers: [{
							...obj,
							// ... {
							// 	showInfoWindow: false,
							// }
						}]
					}
				})
			}
			else {
				closeTimeline()
			}
			prevProps.current = props
		}
	}, [props.showTripsHistory]);

	useEffect(() => {
		const { markers } = state;

		if (!_.isEqual(props.selectedTrip, prevProps.current.selectedTrip)) {
			// We have to hide the FleetSidebar when user slects a trip.
			// We have to display the FleetSidebar when user stops the RouteHistory displaying.
			setState((prevState) => ({ ...prevState, showFleetSidebar: !props.selectedTrip }))
		}

		if (!_.isEqual(props.tripsGPS, prevProps.current.tripsGPS) || !_.isEqual(props.selectedTrip, prevProps.current.selectedTrip)) {
			if (props.showTripsHistory && props.tripsGPS.length) {
				let pos = props.tripsGPS[0].polygon[0]
				if (pos) {
					// FWSD-4032
					if (props.selectedTrip.isLiveTrip) {
						pos = props.tripsGPS[0].polygon[props.tripsGPS[0].polygon.length - 1]
					}
					const position = { lat: pos.lat, lng: pos.lng }
					markers[0].icon_name = markers[0].entry.vehicle_icon
					markers[0].icon_direction = getIconDirection(markers[0].icon_direction, markers[0].position, position, pos.dir)
					markers[0].position = position;
					markers[0].infoData = Object.assign({}, markers[0].infoData, pos, { driver_name: props.selectedTrip.driver_name })
					markers[0].visible_icon = true;
					markers[0].driver_name = props.selectedTrip.driver_name;

					setState((prevState) => {
						return {
							...prevState,
							markers,
						}
					})
				}
				else {
					setState((prevState) => ({
						...prevState,
						markers: [{ ...markers[0], visible_icon: false }]
					}))
				}
			}
			prevProps.current = props;
			map.setCenter(state.center);
			map.setZoom(state.zoom, true);
		}
	}, [props.tripsGPS, props.selectedTrip]);

	useEffect(() => {
		if (!_.isEqual(props.tripTimelineTimestamp, prevProps.current.tripTimelineTimestamp)) {
			if (props.showTripsHistory && props.tripsGPS.length) {
				const pos = _.find(props.tripsGPS[0].polygon, (item) => {
					return moment(item.timestamp) >= moment(props.tripTimelineTimestamp);
				});

				if (pos) {
					const position = { lat: pos.lat, lng: pos.lng };
					const { markers } = state

					markers[0].icon_name = markers[0].entry.vehicle_icon;
					markers[0].icon_direction = getIconDirection(markers[0].icon_direction, markers[0].position, position, pos.dir);
					markers[0].position = position;
					markers[0].infoData = Object.assign({}, markers[0].infoData, pos, { driver_name: props.selectedTrip.driver_name });
					markers[0].visible_icon = true;
					markers[0].driver_name = props.selectedTrip.driver_name;

					setState((prevState) => ({ ...prevState, markers }))
				}
			}
			prevProps.current = props
		}
	}, [props.tripTimelineTimestamp]);

	useEffect(() => {
		if (
			!_.isEqual(props.tripAdvancedPlayerEvent, prevProps.current.tripAdvancedPlayerEvent)
			|| !_.isEqual(props.tripShowShareEvent, prevProps.current.tripShowShareEvent)
			|| !_.isEqual(props.showSnapRoad, prevProps.current.howSnapRoad)
		) { }
	}, [props.tripAdvancedPlayerEvent, props.tripShowShareEvent, props.showSnapRoad, /*props.tripsGPSSnapRoad*/]);

	useEffect(() => {
		if ((!props.location || !props.location.state) && (prevProps.current.company.company.company_id !== props.company.company.company_id)) {
			// *The alerts should be "live" where when the alert occurs. The user should never see an alert from hours previous to them logging in to their account.
			traceUserAccess()
			getVehicleList((markers) => { getDevicesMetadataOnline(markers) }, props.company.company.company_id) // // company.company.company_id && getVehicleList((markers) => { getDevicesMetadataOnline(markers) }, company.company.company_id)
			prevProps.current = props

			if (showZonePanel) {
				getZonePanelData(false);
			} else {
				storedMap?.isShowZP && getZonePanelData(true);
			}
		}
	}, [props.company.company.company_id]);

	useEffect(() => {
		if (state.initDevices.length || state.initEquipments.length) {
			devicesGrouping()
		}
	}, [state.autoValue, state.selectedGroupFleetPanel])

	useEffect(() => {
		if (map) {
			if (props.location && props.location.state.type === 'reports') {
				const coordinates = { lat: props.location.state.lat, lng: props.location.state.lng };
				map.setCenter(coordinates);
				map.setZoom(18);
				addMarker(coordinates);
				navigate(location.pathname, { replace: true, state: null });
			} else if (state.bounds) {
				!!activeTreeItem && map.setCenter(state.center);
				map.setZoom(map.getViewModel().getLookAtData().zoom - 1, !!activeTreeItem);
				getBoundingBox();
				if (!state.showFleetSidebar) {
					map.setCenter(state.center);
					map.setZoom(state.zoom);
				}
			} else if (!getBoundingBox().length) {
				map.setCenter(state.center);
				map.setZoom(state.zoom);
			}
		}
	}, [state.bounds])

	useInterval(() => {
		if (vehiclesType !== 'equipment') {
			const company_name = props.company.company.name
			const partner_name = props.company.company.partner
			// const markers = state.markers
			// const markers_list = markers

			getDevicesEventUpdates(userRole, company_name, partner_name)
				.then((res, err) => {
					const markers_list = state.markers
					// let mmm = []
					// let _alerts = []
					let followmap_position = null

					if (props.showTripsHistory) {
						const initDevices_list = state.initDevices
						res.data.response.devices.map((item, i) => {
							let device = _.find(initDevices_list, (dev) => dev.device_id.toString() === item.device_id.toString())
							if (device) {
								device.online = item.online || device.online
								// mmm.push(device)
								// if (item.events && item.events.length) {
								// 	_alerts = _.union(_alerts, fillAlertsArray({ driver_name: device.driver_name, ...item }))
								// }
							}

							// FWSD-4032
							if (
								props.selectedTrip
								&& props.selectedTrip.isLiveTrip
								&& item.device_id.toString() === state.activeTreeItem.device_id.toString()
								&& props.tripsGPS.length
							) {
								// Gets the last GPS point (props.tripsGPS[0].polygon) of the Live trip (props.selectedTrip)
								const lastTripsGPSPoint = props.tripsGPS[0].polygon[props.tripsGPS[0].polygon.length - 1]


								// If a trip ends (vehicle idles or goes in parking mode) during a live trip, show the Trip is Processing message
								if (!item.ignition.state) {
									props.setSelectedTrip({ ...props.selectedTrip, isLiveTrip: false, isTripProcessing: true })

									const newDeviceTrips = props.deviceTrips.map((devicetrip) => {
										if (devicetrip.route_id === props.selectedTrip.route_id) {
											devicetrip.isLiveTrip = false
											devicetrip.isTripProcessing = true
											devicetrip.end_gps = {
												latitude: (item.gps.lat || lastTripsGPSPoint.lat) * 1,
												longitude: (item.gps.lon || lastTripsGPSPoint.lng) * 1,
												timestamp: item.gps.timestamp,
											}
										}
										return devicetrip
									})
									props.setDeviceTrips(newDeviceTrips)
								}

								// Generates the new last GPS point of the Live trip
								const tripGPSNewPoint = {
									lat: (item.gps.lat || lastTripsGPSPoint.lat) * 1,
									lng: (item.gps.lon || lastTripsGPSPoint.lng) * 1,
									speed: (item.gps.spd || lastTripsGPSPoint.speed) * 1,
									timestamp: moment.utc(item.gps.timestamp).format('YYYY-MM-DD HH:mm:ss'),
									dir: (item.gps.dir || lastTripsGPSPoint.dir) * 1,
									key: ((item.ignition.state || lastTripsGPSPoint.key) * 1).toString(),
									driver_id: lastTripsGPSPoint.driver_id,
									driver_name: lastTripsGPSPoint.driver_name,
									dst: (item.gps.dst || lastTripsGPSPoint.dst) * 1,
								}

								// Stores new last GPS point to the tripsGPS[0].polygon
								props.addTripsGPSPolygonPoint(tripGPSNewPoint)

								// Changes location of the marker on the map
								const item2 = _.find(markers_list, (mark) => mark.device_id.toString() === item.device_id.toString())
								if (item2) {
									item2.entry.online = item.hasOwnProperty('online') ? item.online : item2.entry.online
									if (item.gps) {
										const newGPS = item.gps
										if (_.has(newGPS, 'key')) {
											item2.entry.ignition = { ...item2.entry.ignition, state: newGPS.key }
										} else if (_.has(item.ignition, 'state')) {
											item2.entry.ignition = { ...item2.entry.ignition, state: item.ignition.state }
											newGPS.key = item.ignition.state
										}
										item2.icon_direction = getIconDirection(item2.icon_direction || 'e', item2.position, { lat: newGPS.lat * 1 || 0, lng: newGPS.lon * 1 || 0 }, newGPS.dir)
										item2.position = { lat: newGPS.lat * 1 || item2.position.lat, lng: newGPS.lon * 1 || item2.position.lng }
										item2.infoData = Object.assign({}, item2.infoData, newGPS)
										item2.ignitionСhange = Object.assign({}, item2.ignitionСhange, item.ignition)
									}

									setState((prevState) => {
										return {
											...prevState,
											markers: [item2]
										}
									})
								}
							}
						})

						// const devicestmp = _.uniqWith(_.union(initDevices_list, mmm), _.isEqual)
						// const alertstmp = _.uniqWith(_.union(state.alerts, _alerts), _.isEqual)

						setState((prevState) => {
							return {
								...prevState,
								// initDevices: devicestmp,
								initDevices: initDevices_list,
								// alerts: alertstmp
							}
						})
					}
					else {
						let newInitDevices = state.initDevices
						let hasDeviceStatusChanged = false
						res.data.response.devices.map((item, i) => {
							// Updates the initDevices to calculate the Fleet Activity Satus via useEffect
							// TODO - DONE: make sense to call setFleetStatuses here when found any device status changing
							// instead of calling useEffect (Collects the FLEET ACTIVITY statuses ) each 5 seconds after initDevice storing
							newInitDevices = newInitDevices.reduce((result, initDeviceItem) => {
								if (item.device_id === initDeviceItem.device_id) {
									initDeviceItem = { ...initDeviceItem, ...item }

									const newDeviceStatus = detectDeviceStatus(initDeviceItem)
									if (newDeviceStatus !== initDeviceItem.status) {
										hasDeviceStatusChanged = true
									}
									initDeviceItem.status = newDeviceStatus
								}
								result.push(initDeviceItem)
								return result
							}, [])

							// Autoupdate online, ignition, driver, status properties of the tree selected device
							if (state.activeTreeItem && state.activeTreeItem.device_id === item.device_id) {
								setState((prevState) => {
									return {
										...prevState,
										activeTreeItem: {
											...state.activeTreeItem,
											online: item.online,
											ignition: item.ignition,
											driver_id: item.driver_id,
											driver_name: item.driver_name,
											sleep: item.sleep,
											general_status: item.general_status,
											modem_rssi: item.modem_rssi,
											status: detectDeviceStatus({ ...item, active: state.activeTreeItem.active }) // eventupdates does not return active value
										}
									}
								})
							}

							let item1 = _.find(markers_list, (mark) => mark.device_id.toString() === item.device_id.toString())
							if (item1) {
								item1.entry.online = item.hasOwnProperty('online') ? item.online : item1.entry.online
								if (item.gps) {
									const newGPS = item.gps
									if (_.has(newGPS, 'key')) {
										item1.entry.ignition = { ...item1.entry.ignition, state: newGPS.key }
									} else if (_.has(item.ignition, 'state')) {
										item1.entry.ignition = { ...item1.entry.ignition, state: item.ignition.state }
										newGPS.key = item.ignition.state
									}
									item1.icon_direction = getIconDirection(item1.icon_direction || 'e', item1.position, { lat: newGPS.lat * 1 || 0, lng: newGPS.lon * 1 || 0 }, newGPS.dir)
									item1.position = { lat: newGPS.lat * 1 || item1.position.lat, lng: newGPS.lon * 1 || item1.position.lng }
									item1.infoData = Object.assign({}, item1.infoData, newGPS)
									item1.ignitionСhange = Object.assign({}, item1.ignitionСhange, item.ignition)
								}
							}

							// mmm = _.union(mmm, [].push(item1))

							if (item.gps && item.gps.lat && item.gps.lon && state.centerDevice && (item.device_id == state.centerDevice.device_id)) {
								followmap_position = { lat: item.gps.lat * 1, lng: item.gps.lon * 1 }
							};
							// if (item.events && item.events.length) {
							// 	_alerts = _.union(_alerts, fillAlertsArray({ driver_name: item1.driver_name, ...item }))
							// }
						})

						// if was changed any of device we make recalculation the Fleet Activity statuses and devices tree
						if (hasDeviceStatusChanged) {
							fleetStatusesCalculation(newInitDevices) // ToDo: Check getDevicesEventUpdates here if non-vehicles should be updated
							devicesGrouping(newInitDevices)
						}

						// const markerstmp = _.uniqWith(_.union(markers_list, mmm), _.isEqual)
						// const alertstmp = _.uniqWith(_.union(state.alerts, _alerts), _.isEqual)
						let _state = {
							// markers: markerstmp,
							markers: markers_list,
							// alerts: alertstmp
						}
						if (followmap_position) {
							_state['center'] = { lat: followmap_position.lat, lng: followmap_position.lng }
						}

						setState((prevState) => ({
							...prevState,
							..._state,
							initDevices: newInitDevices,
						}))
					}
				})
				.catch((error) => {
					console.log('!getDevicesEventUpdates error: ', error.response, error)
				})
		}
	}, delayInterval)

	const getAllDevices = (type, companyId, callback) => {
		if (!companyId) return;

		const handleVehicle = () =>
			new Promise((resolve) => {
				getVehicleList((markers, devices, newFiltersFleetPanel) => resolve({
					markers,
					devices,
					newFiltersFleetPanel,
				}), companyId);
			});

		const handleEquipment = () =>
			new Promise((resolve) => {
				getEquipments((markers, equipments, newFiltersFleetPanel) => resolve({
					markers,
					equipments,
					newFiltersFleetPanel,
				}), companyId);
			});

		if (type === 'vehicle') {
			handleVehicle().then(({ markers, devices, newFiltersFleetPanel }) => {
				devicesGrouping(devices, newFiltersFleetPanel);
				fleetStatusesCalculation(devices)
				callback(markers);
			});
		} else if (type === 'equipment') {
			handleEquipment().then(({ markers, equipments, newFiltersFleetPanel }) => {
				devicesGrouping(equipments, newFiltersFleetPanel);
				fleetStatusesCalculation(equipments)
			});
		} else if (type === 'both') {
			Promise.all([handleVehicle(), handleEquipment()]).then((results) => {
				const allMarkers = results.flatMap((r) => r.markers);
				const allDevices = results.flatMap((r) => [...(r.devices || []), ...(r.equipments || [])]);
				const vehicleFiltersFleetPanel = results[0].newFiltersFleetPanel;
				const equipmentFiltersFleetPanel = results[1].newFiltersFleetPanel;
				const newFiltersFleetPanel = {
					...filtersFleetPanel,
					groups: {
						...vehicleFiltersFleetPanel.groups,
						...equipmentFiltersFleetPanel.groups
					}
				}
				setState((prevState) => ({
					...prevState,
					filtersFleetPanel: newFiltersFleetPanel,
				}));
				devicesGrouping(allDevices, newFiltersFleetPanel)
				fleetStatusesCalculation(allDevices)
				callback(allMarkers);
			});
		}
	};

	const getInitDevices = () => {
		switch (vehiclesType) {
			case 'vehicle':
				return state.initDevices;
			case 'equipment':
				return state.initEquipments;
			case 'both':
				return [
					...(state.initDevices || []),
					...(state.initEquipments || [])
				];
			default:
				return [];
		}
	};

	const devicesGrouping = (devicesArg, filtersFleetPanelArg) => {
		const filtersFleetPanelList = filtersFleetPanelArg || filtersFleetPanel;
		const initDevices = getInitDevices();
		let devicesList = devicesArg || initDevices;
		devicesList = DV7access ? devicesList : devicesList.filter(e => dvType(e) !== 'dv7');
		// debugger
		// Looks for vehicles in filtered devices list
		if (state.autoValue !== '') {
			devicesList = devicesList.filter((device) => ((device.vehicle_name ? device.vehicle_name + ' - ' : '') + device.device_id).toLowerCase().includes(state.autoValue))
		}

		const groupedDevices = {}
		devicesList.forEach((device) => {
			let deviceGroupName = device.group_name || 'null';
			const statusKey = device.vehiclesType === 'equipment' ? 'non-vehicle' : device.status;

			// Filters devices through filtersFleetPanel filters
			if ((Object.keys(filtersFleetPanelList.groups).length && !filtersFleetPanelList.groups[deviceGroupName]) || !filtersFleetPanelList.statuses[statusKey]) {
				return
			}

			// Fills the groupedDevices object with list of groups and assigned devices
			if (state.selectedGroupFleetPanel === 'name') {
				const firstChar = (device.vehicle_name || device.name || device.device_id).charAt(0)
				deviceGroupName = !isNaN(firstChar) ? '0-9' : firstChar.toUpperCase()
			}
			else if (state.selectedGroupFleetPanel === 'status') {
				deviceGroupName = statusKey.charAt(0).toUpperCase() + statusKey.slice(1)
			}
			if (groupedDevices[deviceGroupName]) {
				const group = groupedDevices[deviceGroupName]
				group.devices.push(device)
				group.statuses[statusKey]++
				group.value.push(device)
			}
			else {
				const statuses = {
					driving: 0, sleep: 0, offline: 0, 'pending sleep': 0, awake: 0, parked: 0, idling: 0, disabled: 0, 'pending awake': 0, 'non-vehicle': 0,
				}
				statuses[statusKey] = 1

				// checks if current group expanded and set collapsed=false
				const existingGroup = state.groups.find(({ groupName }) => groupName === deviceGroupName)

				groupedDevices[deviceGroupName] = {
					groupName: deviceGroupName,
					devices: [device],
					collapsed: existingGroup ? existingGroup.collapsed : true,
					statuses,
					id: deviceGroupName,
					value: [device]
				}
			}
		})

		const groupNames = _.sortBy(Object.keys(groupedDevices), (group_name) => group_name.toLowerCase())
		const groupedVehiclesResult = groupNames.map((group_name) => (groupedDevices[group_name]))
		setState((prevState) => ({ ...prevState, groups: groupedVehiclesResult }))
	}

	const getBoundingBox = () => {
		let boundsArr = [];
		state.markers.map(e => {
			if (e.position.lat && e.position.lng && e.visible_icon) {
				boundsArr.push({ lat: e.position.lat * 1 || 0, lng: e.position.lng * 1 || 0 });
			}
		});
		if (map && boundsArr.length) {
			const rect = H.geo.Rect.coverPoints(boundsArr, true);
			map.getViewPort().setPadding(100, 100, 100, 100);
			map.getViewModel().setLookAtData({ bounds: rect.getBoundingBox() });
		}

		const obj = map.getObjects().filter(e => e && e instanceof H.map.DomMarker && e.getRemoteId() === 'markerStopReport')[0];
		if (obj) {
			map.removeObject(obj);
		}

		return boundsArr;
	}

	const onSearchChange = (searchValueArg) => {
		const value = searchValueArg.toLowerCase()
		setState((prevState) => ({ ...prevState, autoValue: value }))
	}

	const handleMapMounted = (map) => {
		setMap(map)
	}

	// const documentMouseUp = () => {

	// 	document.removeEventListener('mousemove', splitBlocks);
	// 	document.removeEventListener('mouseup', documentMouseUp);

	// 	// setState({ ...state, center: { lat: state.center.lat, lng: state.center.lng } });
	// 	setState((prevState) => { return { ...prevState, center: { lat: state.center.lat, lng: state.center.lng } } })
	// }

	const setMapCenterTimer = () => {
		setTimeout(() => map && map.setCenter(state.center), 200);
	}

	const setMapCenter = (a) => {
		map && map.setCenter(state.center);
	}

	const getVehicleList = (callback, company_id) => {
		toggleLoader(true);
		const { location } = props

		if (!company_id) {
			return
		}

		getDevicesList(company_id, 'inactive_devices,ignition,modem_rssi,driver,data_usage')
			.then(res => {
				toggleLoader(false);

				let devices = res.data.response.devices
				let markers = []

				let filtersFleetPanelGroups = [] // collects vehicle group names for  filtersFleetPanel.groups item
				let newMonthlyFleetDataUsageAvailable = 0
				devices.map((item, i) => {
					//* Fills the markers array
					if (dashboardRedirect && dashboardRedirect.device_id) {
						if (+item.device_id === +dashboardRedirect.device_id) {
							markers.push({
								position: { lat: 0, lng: 0 },
								icon_name: item.vehicle_icon,
								icon_direction: 'e',
								active: false,
								name: item.vehicle_name || item.device_id,
								device_id: item.device_id,
								entry: item,
								// showInfoWindow: false,
								infoData: null,
								ignitionСhange: null,
								visible_icon: false,
							})
						}
					}
					else {
						markers.push({
							position: { lat: 0, lng: 0 },
							icon_name: item.vehicle_icon,
							icon_direction: 'e',
							active: false,
							name: item.vehicle_name || item.device_id,
							device_id: item.device_id,
							entry: item,
							// showInfoWindow: false,
							infoData: null,
							ignitionСhange: null,
							visible_icon: false,
						})
					}

					item.start_tracking = true

					//FWSD-6748, calculates the available data usage for company
					newMonthlyFleetDataUsageAvailable = newMonthlyFleetDataUsageAvailable + getDeviceDataLimit(item.data_limit, props.company.company.company_data)

					// The device statuses detection
					// TODO: API has to return the device status
					item.status = detectDeviceStatus(item)

					// Fills the filtersFleetPanelGroups array with list of group names
					const deviceGroupName = item.group_name || 'null'
					if (!filtersFleetPanelGroups.includes(deviceGroupName)) {
						filtersFleetPanelGroups.push(deviceGroupName)
					}

					return item
				})
				setMonthlyFleetDataUsageAvailable(newMonthlyFleetDataUsageAvailable * 1024 * 1024 * 1024)

				// set the filtersFleetPanel.groups list
				filtersFleetPanelGroups = _.sortBy(filtersFleetPanelGroups, (group_name) => group_name.toLowerCase())
				const filtersFleetPanelGroupsResult = filtersFleetPanelGroups.reduce((result, group) => {
					result[group] = true
					return result
				}, {})

				const newFiltersFleetPanel = { ...filtersFleetPanel, groups: filtersFleetPanelGroupsResult }

				setState((prevState) => ({
					...prevState,
					initDevices: devices,
					markers,
					// alerts: [],
					autoValue: '',
					activeTreeItem: null,
					filtersFleetPanel: newFiltersFleetPanel,
				}))

				// If user come from the Edit Vehicle page by the "return to map" button
				if (location && location.state && location.state.type === 'return_to_map') {
					const obj = _.find(markers, ['device_id', location.state.id])
					if (obj) {
						setState((prevState) => ({
							...prevState,
							activeTreeItem: obj.entry,
							showVehicleSidebar: true,
							markers,
						}))

						onTreeDeviceClick(obj.entry);
						// ToDo: Refactoring/Check. Any sense of this replace or this navigate? We already are on this route.
						navigate('/', {
							state: undefined,
							replace: true,
						});
					}
				}
				getDashboardRedirect(markers)

				if (typeof callback === 'function') {
					return callback(markers, devices, newFiltersFleetPanel);
				}
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('!getDevicesList error: ', error);

				setState({
					...state,
					initDevices: [],
					groups: [],
					markers: [],
					// alerts: [],
					autoValue: '',
					activeTreeItem: null,
				});

				let errDescription = t('errorMessage.errDescription')
				if (error.response && error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	}

	const getEquipments = (callback, company_id) => {
		toggleLoader(true);

		if (!company_id) {
			return
		}

		getEquipmentsList(company_id, 'bewhere_metadata')
			.then(res => {
				toggleLoader(false);

				let equipments = res.data.response.trackers.map(item => {
					return {
						...item,
						vehiclesType: 'equipment',
						device_id: item.beacon_id,
					}
				});
				let markers = [];

				let filtersFleetPanelGroups = []
				equipments.map((item, i) => {
					const { metadata } = item;

					markers.push({
						position: {
							lat: metadata ? metadata.latitude : 0,
							lng: metadata ? metadata.longitude : 0,
						},
						icon_name: 'equipment',
						active: false,
						device_id: item.beacon_id,
						entry: item,
						visible_icon: true,
						vehiclesType: 'equipment'
					})

					const deviceGroupName = item.group_name || 'null'
					if (!filtersFleetPanelGroups.includes(deviceGroupName)) {
						filtersFleetPanelGroups.push(deviceGroupName)
					}

					return item
				})

				filtersFleetPanelGroups = _.sortBy(filtersFleetPanelGroups, (group_name) => group_name.toLowerCase())
				const filtersFleetPanelGroupsResult = filtersFleetPanelGroups.reduce((result, group) => {
					result[group] = true
					return result
				}, {})

				const newFiltersFleetPanel = { ...filtersFleetPanel, groups: filtersFleetPanelGroupsResult }

				setState((prevState) => ({
					...prevState,
					initEquipments: equipments,
					markers,
					activeTreeItem: null,
					filtersFleetPanel: newFiltersFleetPanel,
				}))

				if (typeof callback === 'function') {
					return callback(markers, equipments, newFiltersFleetPanel);
				}
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('!getEquipmentsList error: ', error);

				setState({
					...state,
					initDevices: [],
					groups: [],
					markers: [],
					activeTreeItem: null,
				});

				let errDescription = t('errorMessage.errDescription')
				if (error.response && error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	}

	const addMarker = (coordinates) => {
		const div = document.createElement('div');
		const img = document.createElement('img');
		const label = document.createElement('label');
		div.setAttribute('class', 'markerZone');
		label.setAttribute('class', 'markerLabel');
		img.setAttribute('src', '/images/markerZone.svg');

		label.style.fontSize = '15px';
		label.style.transform = 'translate(-50%, -450%)';
		img.style.width = '29px';
		img.style.height = '39px';
		label.innerText = `lat: ${coordinates.lat.toFixed(2)}, lng: ${coordinates.lng.toFixed(2)}`;
		div.style.pointerEvents = 'none';
		div.appendChild(img);
		div.appendChild(label);

		const position = { lat: coordinates.lat, lng: coordinates.lng };
		const marker = new H.map.DomMarker(position, {
			icon: new H.map.DomIcon(div)
		});

		marker.setRemoteId('markerStopReport');
		map.addObject(marker);
	}

	const getIconDirection = (direction_old, pos_old, pos_new, dir) => {
		let direction = direction_old;

		if (dir && dir > 0) {
			if (dir > 337.5 || dir <= 22.5)
				direction = "n";
			else if (dir > 22.5 && dir <= 67.5)
				direction = "ne";
			else if (dir > 67.5 && dir <= 112.5)
				direction = "e";
			else if (dir > 112.5 && dir <= 157.5)
				direction = "se";
			else if (dir > 157.5 && dir <= 202.5)
				direction = "s";
			else if (dir > 202.5 && dir <= 247.5)
				direction = "sw";
			else if (dir > 247.5 && dir <= 292.5)
				direction = "w";
			else if (dir > 292.5 && dir <= 337.5)
				direction = "nw";
		}
		else {
			const angleFromCoordinate = (latlng1, latlng2) => {
				const rad = Math.PI / 180,
					lat1 = latlng1.lat * rad,
					lat2 = latlng2.lat * rad,
					lon1 = latlng1.lng * rad,
					lon2 = latlng2.lng * rad,
					y = Math.sin(lon2 - lon1) * Math.cos(lat2),
					x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1),
					bearing = ((Math.atan2(y, x) * 180 / Math.PI) + 360) % 360;

				return bearing >= 180 ? bearing - 360 : bearing
			}

			const heading = angleFromCoordinate(pos_old, pos_new);

			if (heading == 0 || (pos_old.lat == 0 && pos_old.lng == 0)) {
				return direction_old;
			}

			if (heading > -24 && heading < 23) {
				direction = 'n';
			}
			else if (heading > -68 && heading < -24) {
				direction = 'nw';
			}
			else if (heading > -113 && heading < -69) {
				direction = 'w';
			}
			else if (heading > -158 && heading < -114) {
				direction = 'sw';
			}
			else if (heading > 23 && heading < 69) {
				direction = 'ne';
			}
			else if (heading > 68 && heading < 114) {
				direction = 'e';
			}
			else if (heading > 113 && heading < 158) {
				direction = 'se';
			}
			else if (heading < -159 || heading > 158) {
				direction = 's';
			}
		}

		return direction;
	}

	// const fillAlertsArray = (item) => {
	// 	const { alert_gsensor, alert_speed } = state.alert_filters
	// 	let deviceAlerts = []
	// 	if (item.events && item.events.length) {
	// 		item.events.map((alert, i) => {
	// 			if (alert.id /*&& state.alertsRemoved.indexOf(alert.id) == -1*/) {
	// 				if (['FatalGSensor', 'GSensor'].indexOf(alert.name) > -1 && !alert_gsensor) {
	// 					return false
	// 				}
	// 				else if (alert.name == "HighSpeed" && !alert_speed) {
	// 					return false
	// 				}

	// 				deviceAlerts.push({
	// 					title: convertAlertName(alert.name),
	// 					starttime: alert.starttime,
	// 					endtime: alert.endtime,
	// 					asset: (item.vehicle_name || item.device_id),
	// 					device_id: item.device_id,
	// 					id: alert.id,
	// 					channel: (alert.channel) ? alert.channel : '',
	// 					driver_name: item.driver_name,
	// 				})
	// 			}
	// 		})
	// 	}
	// 	return deviceAlerts
	// }

	const setMarkersBound = () => {
		const { user } = props
		const { bounds } = state

		if (bounds && map) {
			map.getViewModel().setLookAtData({ bounds });
		}
		else {
			setState((prevState) => ({
				...prevState,
				zoom: user.user.settings.zoom_level || 6
			}))
		}
	}

	const getDevicesMetadataOnline = (argMarkers = null) => {
		if (delayInterval) {
			setDelayInterval(null)
		}

		const { company } = props
		const company_name = company.company.name
		const partner_name = company.company.partner

		if (!company_name || !partner_name) {
			return
		}

		getDevicesLastgps({ user_role: userRole, company_name, partner_name, inactive: true })
			.then((res, err) => {
				let mmm = []
				// let _alerts = []
				let bounds = map?.getViewModel().getLookAtData().bounds.getBoundingBox();
				let boundsArr = []
				const markers_list = argMarkers || state.markers

				res.data.response.devices.map((item, i) => {
					const _markers = markers_list.map((item1, i) => {
						if (item1.device_id == item.device_id) {
							item1.driver_name = item.driver_name
							item1.entry.online = item.online
							item1.visible_icon = false

							const newGPS = item.gps
							if (newGPS && newGPS.lat) {
								if (_.has(newGPS, 'key')) {
									item1.entry.ignition = { ...item1.entry.ignition, state: newGPS.key }
								} else if (_.has(item.ignition, 'state')) {
									item1.entry.ignition = { ...item1.entry.ignition, state: item.ignition.state }
									newGPS.key = item.ignition.state
								}
								item1.icon_direction = getIconDirection(item1.icon_direction || 'e', item1.position, { lat: newGPS.lat * 1 || 0, lng: newGPS.lon * 1 || 0 }, newGPS.dir)
								item1.position = { lat: newGPS.lat * 1 || 0, lng: newGPS.lon * 1 || 0 }
								item1.infoData = Object.assign({}, item1.infoData, newGPS)
								item1.ignitionСhange = Object.assign({}, item1.ignitionСhange, item.ignition)
								item1.visible_icon = true
							} else {
								item1.infoData = ''
								item1.ignitionСhange = ''
								item1.position = { lat: 0, lng: 0 }
							}
						}

						return item1
					})

					mmm = _.union(mmm, _markers)

					if (item.gps && item.gps.lat && item.gps.lon) {
						boundsArr.push({ lat: item.gps.lat * 1 || 0, lng: item.gps.lon * 1 || 0 })
					}
					// if (item.events && item.events.length) {
					// 	_alerts = _.union(_alerts, fillAlertsArray(item))
					// }
				})

				if (boundsArr.length) {
					if (map) {
						const rect = H.geo.Rect.coverPoints(boundsArr, true);
						map.getViewModel().setLookAtData({ bounds: rect.getBoundingBox() });
					}
				} else {
					setState((prevState) => {
						return {
							...prevState,
							zoom: props.user.user.settings.zoom_level || 6
						}
					})
					bounds = null;
				}

				const markerstmp = _.uniqWith(_.union(markers_list, mmm), _.isEqual)
				// const alertstmp = _.uniqWith(_.union(state.alerts, _alerts), _.isEqual)

				setState((prevState) => {
					return {
						...prevState,
						bounds,
						markers: markerstmp,
						// alerts: alertstmp
					}
				})
			})
			.catch((error) => {
				console.log('!getDevicesLastgps error: ', error);

				let errDescription = t('errorMessage.errDescription')
				if (error.response && error.response.data && error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			})


		if (state.company_trace_active) {
			setDelayInterval(5000)
		}
	}

	const onZoomChangedManually = (e, p) => {
		const zoom = map.getZoom()
		setState((prevState) => { return { ...prevState, zoom } })
	}

	const onMaptypeChangedManually = () => {

	}

	const onClickAddress = (device_id) => {
		const { markers } = state
		const marker = _.find(markers, ['device_id', device_id])
		const { lat, lng } = marker.position
		marker.infoData.address = 'Loading'
		setState((prevState) => ({ ...prevState, markers }))

		getDeviceAddress({ lat, lng })
			.then((res) => {
				let address = formatAddress(res.data.response.address)
				marker.infoData.address = address || t('homePage.notAvailable')
				setState((prevState) => ({ ...prevState, markers }))
			})
			.catch(err => {
				console.log(err)
			})
	}

	const onSelectMarker = (device_id) => {
		const { activeTreeItem } = state
		let markerEntry = null
		let selectedDevice
		const markers = state.markers.map((item) => {
			if (item.device_id === device_id) {
				selectedDevice = item
				markerEntry = item.entry
			}
			// else {
			// 	item.showInfoWindow = false
			// }

			return item
		})

		if (selectedDevice) {
			if (activeTreeItem && device_id === activeTreeItem.device_id) {
				// selectedDevice.showInfoWindow = false
				if (selectedDevice.infoData) {
					selectedDevice.infoData.address = ''
				}

				setState((prevState) => {
					return {
						...prevState,
						showVehicleSidebar: false,
						activeTreeItem: null
					}
				})
			} else {
				if (selectedDevice.infoData) {
					selectedDevice.infoData.address = ''
				}
				const newGroups = state.groups.map((item) => {
					item.collapsed = true
					if (item.groupName === selectedDevice.entry.group_name) {
						item.collapsed = false
					}
					return item
				})

				zoomToVehicle(15, markerEntry)
				setState((prevState) => {
					return {
						...prevState,
						showVehicleSidebar: true,
						activeTreeItem: markerEntry,
						groups: newGroups,
					}
				})
			}
		} else {
			setMarkersBound()
		}

		setState((prevState) => ({
			...prevState,
			markers
		}))
	}

	const onTreeGroupNodeClick = (treeGroupArg) => {
		const newGroups = state.groups.map((item) => {
			if (item.groupName === treeGroupArg.groupName) {
				item.collapsed = !item.collapsed
			}
			return item
		})

		setState((prevState) => ({ ...prevState, groups: newGroups }))
	}

	const onTreeDeviceClick = (entry) => {
		setShowTripsHistory(false)

		// FWSD-6476 - if the navigation menu panel is extended when the vehicle panel opens, the menu panel should automatically be collapsed
		// to maximize screen space and not make the window feel cluttered.
		if (!state.activeTreeItem) {
			props.updateSideMenuOpen(false)
		}

		const markers = [...state.markers];
		const selectedDevice = markers.find(vehicle => vehicle.device_id === entry.device_id);
		const { activeTreeItem } = state;
		if (selectedDevice) {
			// DEVICE ALREADY ACTIVE
			if (activeTreeItem && selectedDevice.device_id === activeTreeItem.device_id) {
				if (selectedDevice.infoData) {
					selectedDevice.infoData.address = ''
				}
				setState((prevState) => {
					return {
						...prevState,
						showVehicleSidebar: false,
						activeTreeItem: null
					}
				})
			}
			else {
				if (selectedDevice.infoData) {
					selectedDevice.infoData.address = ''
				}
				if (selectedDevice.position.lat !== 0) {
					zoomToVehicle(15, entry)
					map.setCenter({ lat: selectedDevice.position.lat, lng: selectedDevice.position.lng });
					setState((prevState) => ({ ...prevState, showVehicleSidebar: true }))
				}
				else {
					setState((prevState) => ({ ...prevState, showVehicleSidebar: true }))
					toastr.info(t('toastMessage.toastrInfoUnavailable'));
				}
				setState((prevState) => ({
					...prevState,
					markers,
					activeTreeItem: entry
				}))
			}
		} else {
			setMarkersBound()
			setState((prevState) => ({ ...prevState, activeTreeItem: entry }))
		}

		setState((prevState) => ({ ...prevState, markers }))
	}

	const liveVideoUserAccess = () => {
		const { user } = props
		const userPermission = user.user.company_data

		if (!userPermission.live_active && ['fleet_manager', 'fleet_maintainer', 'group_manager', 'user'].indexOf(userRole) > -1) {
			return false
		}
		else {
			return true
		}
	}

	const traceUserAccess = () => {
		const { user } = props
		const companyPermissions = user.user.company_data

		if (!companyPermissions.trace_active && ['fleet_manager', 'fleet_maintainer', 'group_manager', 'user'].indexOf(userRole) > -1) {
			setState((prevState) => ({
				...prevState,
				company_trace_active: false
			}))
		}
		else {
			setState((prevState) => ({
				...prevState,
				company_trace_active: true
			}))
		}
	}

	const zoomToVehicle = (zoomSize, entry) => {
		const { activeTreeItem, markers } = state
		if (!entry && !activeTreeItem) {
			toastr.warning('', t('toastMessage.toastrWarningSelectVehicle'));
			return;
		}

		const activeDeviceId = (entry || activeTreeItem).device_id;
		const activemarker = markers.filter(marker => marker.device_id == activeDeviceId && marker.visible_icon);

		if (activemarker.length) {
			map.setZoom(zoomSize);
			map.setCenter(activemarker[0].position);
			setState((prevState) => ({
				...prevState,
				zoom: zoomSize,
				center: activemarker[0].position
			}))
		}
	}

	const openClip = (event, eventId) => {
		event.preventDefault();

		const { user, company } = props
		const winOpen = {
			eventId: eventId,
			userRole: user.user.roles[0],
			companyName: company.company.name,
			partnerName: company.company.partner,
			driverRecognition: company.company.driver_recognition,
			user: user.user,
		}
		localStorage.setItem('winOpen', JSON.stringify(winOpen));

		const width = 1200
		const height = 800
		const w = window
		const d = document
		const e = d.documentElement
		const g = d.getElementsByTagName('body')[0]
		const winWidth = w.innerWidth || e.clientWidth || g.clientWidth
		const winHeight = w.innerHeight || e.clientHeight || g.clientHeight
		const winX = (document.all) ? window.screenLeft : window.screenX
		const winY = (document.all) ? window.screenTop : window.screenY
		const left = ((winWidth - width) / 2) + winX
		const top = ((winHeight - height) / 2) + winY
		const windowSpecs = 'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=1,width=' + width + ',height=' + height + ',left=' + left + ',top=' + top
		const target = eventId
		const win = window.open('/event/video/' + target, target + '1', windowSpecs);

		return win
	}

	const onClickPlayback = (current) => {
		const { tripsGPS } = props

		if (!moment.isMoment(current)) {
			current = moment(current.time)
		}

		if (tripsGPS.length && tripsGPS[0].polygon.length) {
			const pos = _.find(tripsGPS[0].polygon, (item) => {
				return moment(item.timestamp) >= current;
			});

			if (pos) {
				const position = { lat: pos.lat, lng: pos.lng };
				const { markers } = state

				markers[0].icon_name = markers[0].entry.vehicle_icon;
				markers[0].icon_direction = getIconDirection(markers[0].icon_direction, markers[0].position, position, pos.dir);
				markers[0].position = position;
				markers[0].infoData = Object.assign({}, markers[0].infoData, pos);
				markers[0].visible_icon = true;

				setState((prevState) => ({ ...prevState, markers }))
			}
			else {
				const { markers } = state

				if (markers.length) {
					markers[0].visible_icon = false;
				}
				setState((prevState) => ({ ...prevState, markers }))
			}
		}
		else {
			const { markers } = state

			if (markers.length) {
				markers[0].visible_icon = false;
			}
			setState((prevState) => ({ ...prevState, markers }))
		}
	}

	const openAdvancedPlayer = (event) => {
		setState((prevState) => ({
			...prevState,
			showAdvancedPlayer: true,
			selectedEvent: event
		}))
	}

	const closeTimeline = () => {
		// state.alertdevices.map((item, i) => item.entry.start_playback = false);
		setState((prevState) => ({
			...prevState,
			// alertdevices: [],
			// alertshistory: [],
			markers: [],
			// polygons: [],
			maptype: 'roadmap', //'hybrid',
			tripHeight: -14,
			additionalClassName: 'tripReplayPanelClosed',
		}))

		//* Start setInterval
		let _markers = [];
		state.initDevices.map((item, i) => {
			//* Fills the markes array
			let name = item.vehicle_name || item.device_id;
			_markers.push({
				position: { lat: 0, lng: 0 },
				icon_name: item.vehicle_icon,
				icon_direction: 'e',
				active: false,
				name: name,
				device_id: item.device_id,
				entry: item,
				// showInfoWindow: false,
				infoData: null,
				ignitionСhange: null,
				visible_icon: false
			});

			item.start_tracking = true;
			item.online = false;
			return item;
		});

		setState((prevState) => ({ ...prevState, markers: _markers }))
		getDevicesMetadataOnline(_markers);
	}

	const onClickLiveTraffic = () => {
		const { showLiveTraffic } = state
		setState((prevState) => ({ ...prevState, showLiveTraffic: !showLiveTraffic }))
	}

	const onCloseEventVideoAll = () => {
		const { setTripAdvancedPlayerEvent } = props
		setTripAdvancedPlayerEvent(null)
		setState((prevState) => ({
			...prevState,
			showAdvancedPlayer: false,
			selectedEvent: null
		}))
	}

	const onCloseShareEvent = () => {
		const { setTripShowShareEvent } = props
		setTripShowShareEvent(null)
		setState((prevState) => ({ ...prevState, showShareEvent: false }))
	}

	const openShareEvent = (event) => {
		setState((prevState) => ({
			...prevState,
			showShareEvent: true,
			selectedEvent: event
		}))
	}

	const onFlagEvent = (row) => {
		const { id, flagged } = row

		toggleLoader(true);
		if (!flagged) {
			apiCall('PUT', '/events/{id}/flagged', { id })
				.then((res, err) => {
					if (!_.isEmpty(props.tripAdvancedPlayerEvent)) {
						let selectedEvent = props.tripAdvancedPlayerEvent;
						selectedEvent.flagged = true;
						props.setTripAdvancedPlayerEvent(selectedEvent)
					}
					else {
						row.flagged = true
					}
					toggleLoader(false);
				})
				.catch((error) => {
					toggleLoader(false);
					console.log('!onFlagEvent put error:', error.response, error)

					let errDescription = t('errorMessage.errDescription')
					if (error.response.data.response.error) {
						errDescription = error.response.data.response.error
					}
					toastr.error(errDescription)
				})
		}
		else {
			apiCall('DELETE', '/events/{id}/flagged', { id })
				.then((res, err) => {
					if (!_.isEmpty(props.tripAdvancedPlayerEvent)) {
						let selectedEvent = props.tripAdvancedPlayerEvent;
						selectedEvent.flagged = false;
						props.setTripAdvancedPlayerEvent(selectedEvent)
					}
					else {
						row.flagged = false
					}
					toggleLoader(false);
				})
				.catch((error) => {
					toggleLoader(false);
					console.log('!onFlagEvent delete error:', error.response, error)

					let errDescription = t('errorMessage.errDescription')
					if (error.response.data.response.error) {
						errDescription = error.response.data.response.error
					}
					toastr.error(errDescription)
				})
		}
	}

	const updateDriver = (event_id, driver) => {
		// const updatedEvents = [...state.alerts];
		// updatedEvents.map(event => {
		// 	if (event.id === event_id) {
		// 		event.driver_name = driver.first_name + ' ' + driver.last_name
		// 		event.driver_id = driver.id
		// 		setState((prevState) => { return { ...prevState, selectedEvent: event } })
		// 	}
		// })
		// setState((prevState) => { return { ...prevState, alerts: updatedEvents } })
	}

	const openEventNote = () => {
		setState((prevState) => ({ ...prevState, showEventNote: true }))
	}

	const onSaveEventNote = (eventNoteData) => {
		if (eventNoteData) {
			if (state.selectedEvent) {
				let selectedEvent = state.selectedEvent;
				selectedEvent.event_notes = eventNoteData.note;
				selectedEvent.has_review = eventNoteData.reviewed;

				setState((prevState) => { return { ...prevState, selectedEvent, showEventNote: false } })
			}
			else if (props.tripAdvancedPlayerEvent) {
				let selectedEvent = props.tripAdvancedPlayerEvent;
				selectedEvent.event_notes = eventNoteData.note;
				selectedEvent.has_review = eventNoteData.reviewed;
				props.setTripAdvancedPlayerEvent(selectedEvent)

				setState((prevState) => { return { ...prevState, showEventNote: false } })
			}
		}
	}

	// FWSD-879
	const onClickSnapRoad = () => {
		const { tripsGPS, setTripsGPSSnapRoad, showSnapRoad, setShowSnapRoad } = props

		if (showSnapRoad === true) {
			setShowSnapRoad(!showSnapRoad)
			return
		} else {
			setShowSnapRoad(!showSnapRoad)
		}

		if (tripsGPS.length) {
			const HERE_API_KEY = process.env.REACT_APP_HERE_MAPS_API_KEY;
			const snapRoadGPS = []
			tripsGPS.forEach((trip) => {
				const tripGPS = trip.polygon
				const requestArray = []
				let pathValues = []
				let lastDst = 0
				tripGPS.forEach(({ lat, lng, dst }, i) => {
					if (i === 0) {
						lastDst = dst
						pathValues.push(`${lat},${lng}`)
						return
					}

					// filter of points:
					// 1. coordinates next point should differ from previous
					// 2. distance between points shuld be more 100 meters
					// 3. if next distance less prevous then take this point
					if (
						(tripGPS[i - 1].lat === lat && tripGPS[i - 1].lng === lng)
						|| (tripGPS[i - 1].dst > lastDst && tripGPS[i - 1].dst - lastDst < 100)
					) {
						return
					}

					lastDst = dst
					pathValues.push(`${lat},${lng}`)
					// map span to roads allows just 100 points per request
					if (pathValues.length === 100) {
						requestArray.push(axios.get(`https://router.hereapi.com/v8/routes?xnlp=CL_JSMv3.1.57.0&apikey=${HERE_API_KEY}&routingMode=fast&transportMode=car&return=polyline&via=${new H.service.Url.MultiValueQueryParameter(pathValues.map(wp => `${wp.lat},${wp.lng}`))}`))
						pathValues = []
					}
				})
				if (pathValues.length) {
					requestArray.push(axios.get(`https://router.hereapi.com/v8/routes?xnlp=CL_JSMv3.1.57.0&apikey=${HERE_API_KEY}&routingMode=fast&transportMode=car&return=polyline&via=${new H.service.Url.MultiValueQueryParameter(pathValues.map(wp => `${wp.lat},${wp.lng}`))}`))
				}

				if (requestArray.length) {
					toggleLoader(true);
					Promise.all(requestArray)
						.then(res => {
							if (res.routes.length) {
								const snapCoords = []
								res.forEach((snap) => {
									res.routes[0].sections[0].polyline.forEach((point) => {
										snapCoords.push({
											lat: point.lat,
											lng: point.lng,
										})
									})
								})
								setTripsGPSSnapRoad([
									{
										polygon: snapCoords,
										starttimestamp: trip.starttimestamp,
										endtimestamp: trip.endtimestamp,
									}
								])
							}
							toggleLoader(false);
						})
						.catch(error => {
							toggleLoader(false);
							console.log('Promise.all error: ', error.response, error)
							toastr.error(t('toastMessage.toastrErrorGetSnapRoad'))
						},
						)

				}
			})
		}
	}

	// FWSD-4405, FWSD-7381
	const getDashboardRedirect = (argMarkers) => {
		const { dashboardRedirect } = props
		const varMarkers = argMarkers || state.markers

		if (dashboardRedirect && dashboardRedirect.type) {
			switch (dashboardRedirect.type) {
				case 'redirectFromDailyEvents':
				case 'redirectFromUnknownDrivers':
					const obj = _.find(varMarkers, ['device_id', dashboardRedirect.device_id.toString()])
					if (obj) {
						setShowTripsHistory(true)
						setState((prevState) => { return { ...prevState, activeTreeItem: obj.entry, showVehicleSidebar: true } })
					}
					break;
				case 'redirectFromBellNotificationsOpenLS':
					const obj1 = _.find(varMarkers, ['device_id', dashboardRedirect.device_id.toString()])
					if (obj1) {
						setState((prevState) => { return { ...prevState, activeTreeItem: obj1.entry, showFleetSidebar: true, showVehicleSidebar: true } })
						openLiveStream(userRole, obj1.entry)
					}
					props.setDashboardRedirect(null)
					break;
				default:
					break;
			}
		}
	}

	const { activeTreeItem, showVehicleSidebar, showFleetSidebar, selectedGroupFleetPanel, filtersFleetPanel } = state;

	if (!user) {
		return (<div></div>)
	}

	const setFiltersFleetPanel = (fultersArg) => {
		setState((prevState) => ({ ...prevState, filtersFleetPanel: fultersArg }))
		devicesGrouping()
	}

	// Collects the FLEET ACTIVITY statuses
	const fleetStatusesCalculation = (initDevicesArg) => {
		const initDevices = initDevicesArg || state.initDevices
		const initStatuses = { driving: 0, sleep: 0, offline: 0, 'pending sleep': 0, awake: 0, parked: 0, idling: 0, disabled: 0, 'pending awake': 0, 'non-vehicle': 0, }

		const newFleetStatuses = initDevices.reduce((result, device) => {
			const statusKey = device.vehiclesType === 'equipment' ? 'non-vehicle' : device.status;
			result[statusKey] = (result[statusKey] || 0) + 1
			return result
		}, {})

		setFleetStatuses({ ...initStatuses, ...newFleetStatuses })
	}

	const renderFleetActivityStatus = () => {
		const deviceStatuses = [
			...(['vehicle', 'both'].includes(vehiclesType) ? [
				'driving',
				'parked',
				'awake',
				'sleep',
				'idling',
				'offline',
				'disabled',
			] : []),
			...(['equipment', 'both'].includes(vehiclesType) ? ['non-vehicle'] : []),
		];
		const res = [];
		const fleetStatusesKeys = getAvailableFleetStatuses(Object.keys(fleetStatuses)).filter(value => deviceStatuses.includes(value))

		fleetStatusesKeys.forEach((status_name) => {
			const title_status_name = t(`homePage.fleetStatuses.${status_name.replace(' ', '_')}`, status_name);
			res.push(
				<div key={status_name} className={`status-row ${fleetStatusesKeys.length >= 3 ? 'full-access' : ''}`}>
					<div className={`icon ${status_name.replace(' ', '_')}`} />
					<div>
						<InfoPop
							title={`${t('homePage.activityStatus')} - ${title_status_name.charAt(0).toUpperCase() + title_status_name.slice(1)}`}
							body={deviceStatusPopups()[status_name]}
						>
							<span className="title">{title_status_name}</span>
						</InfoPop>
					</div>
					{fleetStatuses[status_name]}
				</div>
			)
		})

		return res
	}

	const getActiveMarkerInfo = (device_id) => {
		if (activeTreeItem && activeTreeItem.device_id === device_id) {
			let markerInfo = state.markers.find(marker => marker.device_id === device_id)
			if (markerInfo) {
				markerInfo.speed_unit = props.user.user.speed_unit
			}
			return markerInfo
		}
		else {
			return null
		}
	}

	const getZonePanelData = async (value) => {
		if (value) {
			const localTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
			const { user: { user = {} } = {} } = props;
			const { settings = {} } = user;
			const userTZ = settings.time_zone || null;
			localStorage.setItem("storedMap", JSON.stringify({ ...storedMap, isShowZP: true }));
			toggleLoader(true);
			const params = {
				include_data: 'movement',
				date: moment().format('YYYYMMDDhhmmss'),
				tzname: userTZ ? userTZ : localTZ,
			};
			await getCompanyZones(props.company.company.company_id, params)
				.then(res => {
					let zones = res.data.response || [];
					if (zones.length) {
						const localZones = storedMap?.checkedZones;
						if (localZones?.length) {
							zones = zones.map(zone => {
								const obj = _.find(localZones, { 'id': zone.id });
								if (obj) {
									zone = {
										...zone,
										checked: obj.checked,
										open: obj.open,
										viewAll: obj.viewAll
									}
								} else {
									zone = {
										...zone,
										checked: false,
										open: false,
										viewAll: false
									}
								}

								return zone;
							})
						} else {
							zones = zones.map(zone => ({
								...zone,
								checked: false,
								open: false,
								viewAll: false
							}))
						}
					}

					zones = zones.map(zone => ({ ...zone, movement: _.orderBy(zone?.movement, ['timestamp'], ['desc']) }));
					setZones(zones);
					toggleLoader(false);
				})
				.catch((error) => {
					console.log('!get Zones error: ', error);
					toastr.error(t('homePage.zonePanel.errZones'));
					toggleLoader(false);
				})
		} else {
			localStorage.setItem("storedMap", JSON.stringify({ ...storedMap, isShowZP: false, checkedZones: [] }));
			setZones([]);
		}
		setShowZonePanel(value);
	};

	const setVehiclesType = (type) => {
		dispatch({
			type: 'SET_VEHICLES_TYPE',
			payload: type,
		})
	};

	const setSortType = (value) => {
		setState((prevState) => ({
			...prevState,
			selectedGroupFleetPanel: value
		}))
	}

	return (
		<div>
			<div className="tracking-content" style={{ position: 'relative' }} >
				<GreyHeader
					title={t('homePage.header')}
					subtitle={props.company.company.name}
					showZonePanel={storedMap?.isShowZP || showZonePanel}
					enabledZonesAccess={props.company.company.company_data?.geofencing_active}
					setShowZonePanel={getZonePanelData}
				/>
				<main className={`gps-tracking show-fleet-pannel show-vehicle-pannel showVehicleSidebar`}
					style={{ position: 'relative', clear: 'both', overflow: 'auto' }}
				>
					<div className="track-container-wrap">
						<div className="track-container-inner" style={{ display: 'flex', position: 'relative', height: 'calc(100vh - 67px)' }}>
							<div style={{ display: 'flex', position: 'relative', }}>
								{showFleetSidebar &&
									<div id="block-tree" style={{ float: 'left', position: 'relative', height: 'calc(100vh - 67px)', width: '300px' }}>

										<div className='vehicle-list-wrapper'>
											<div className='fleet-activity-status'>
												<div className="header">{t('homePage.statusOverview')}</div>
												<div className="body">
													{renderFleetActivityStatus()}
												</div>
											</div>
											<BaseButtonGroup
												options={vehiclesOptions}
												value={vehiclesType}
												onClickHandler={setVehiclesType}
												className='vehicles-type-group'
											/>
											<SearchBar
												placeholder={t('homePage.searchBarPlaceholder')}
												term={state.autoValue}
												onSearch={(e) => onSearchChange(e.target.value)}
											/>

											<div className="vehicles-sort-wrapper">
												<h5>{t('homePage.vehiclesSortWrapper')}</h5>
												<BaseButtonGroup
													options={sortOptions}
													value={selectedGroupFleetPanel}
													onClickHandler={setSortType}
													className='sort-type-group'
												/>
												<div className="vehicles-sort-filter">
													<TreeVehiclesFilter
														filters={getAvailableFleetStatuses(filtersFleetPanel, 'filters')}
														setFiltersFleetPanel={setFiltersFleetPanel}
													/>
												</div>
											</div>

											<TreeVehicles
												deviceGroups={state.groups}
												activeTreeItem={state.activeTreeItem}
												showTripsHistory={showTripsHistory}
												userRole={userRole}
												markers={state.markers}
												onTreeDeviceClick={onTreeDeviceClick}
												onTreeGroupNodeClick={onTreeGroupNodeClick}
											/>
										</div>
									</div>
								}

								{showVehicleSidebar && activeTreeItem &&
									<div className="vehicle-sidebar">
										{showVehicleSidebar && activeTreeItem
											&& (
												<VehicleSidebar
													activeTreeItem={activeTreeItem}
													markerInfo={getActiveMarkerInfo(activeTreeItem.device_id)}
													monthlyFleetDataUsageAvailable={monthlyFleetDataUsageAvailable}
													companyDevicesCount={state.initDevices.length}
													map={map}
													onClickPlayback={onClickPlayback}
													openAdvancedPlayer={openAdvancedPlayer}
													selectedTrip={selectedTrip}
													zoomToVehicle={zoomToVehicle}
												/>
											)}
									</div>
								}

								{/* Vehicle right sidebar */}
								<button
									style={{ left: '100%' }}
									className="vehicle-sidebar-toggle"
									title={`${!activeTreeItem ? t('homePage.vehicleSidebarToggle') : ''}`}
									onClick={() => {
										if (!showFleetSidebar) {
											const newState = { showFleetSidebar: true }
											if (activeTreeItem) {
												newState.showVehicleSidebar = true
											}

											setState((prevState) => ({ ...prevState, ...newState }))
										}
										else if (showVehicleSidebar) {
											setState((prevState) => ({ ...prevState, showVehicleSidebar: false }))
										}
										else if (showFleetSidebar) {
											setState((prevState) => ({ ...prevState, showFleetSidebar: false }))
										}
									}}
								>
									{!showFleetSidebar
										? <FaTruckMoving />
										: <IoIosArrowBack color='#ED1E79' />
									}
								</button>
							</div>
							<div id="map-block" className={classnames(state.additionalClassName, { "hybrid": state.maptype == 'hybrid' })} style={{ width: '100%', position: 'initial', height: '100%' }}>
								<div className="row1" style={{ marginRight: 0, position: 'relative', height: isMobileOnly ? 'calc(100% - 15px)' : '100%' }}>
									<SimpleMapExample
										userRole={userRole}
										markers={state.markers}
										center={state.center}
										zoom={state.zoom}
										maptype={state.maptype}
										speed_unit={props.user.user.speed_unit}
										liveVideoUserAccess={liveVideoUserAccess()}
										// polygons={state.polygons}
										snapRoadGPS={state.snapRoadGPS}
										onMapMounted={handleMapMounted}
										onSelectMarker={onSelectMarker}
										onClickAddress={onClickAddress}
										onZoomChanged={onZoomChangedManually}
										onMapTypeIdChanged={onMaptypeChangedManually}
										setMap={setMap}
										setMapUI={setMapUI}
										showLiveTraffic={state.showLiveTraffic}
										onClickLiveTraffic={onClickLiveTraffic}
										onClickSnapRoad={onClickSnapRoad}
										openClip={openClip}
										activeTreeItem={activeTreeItem}
										getBoundingBox={getBoundingBox}
									/>

									{/* Displays the Trip Snapshot Carousel --FWSD-4740 */}
									{selectedTrip && <TripSnapshots map={map} activeTreeItem={activeTreeItem} />}

									{(!state.company_trace_active) ? <div className="gray-map"></div> : ''}
								</div>
							</div>
							{showZonePanel && (
								<ZonePanel
									isCollapsed={isZonePanelCollapsed}
									setIsCollapsed={setIsZonePanelCollapsed}
									zones={zones}
									map={map}
									mapUI={mapUI}
								/>
							)}
						</div>
					</div>
				</main>
			</div>

			{((!_.isEmpty(tripAdvancedPlayerEvent) && (tripAdvancedPlayerEvent.uploading_status === 'VIDEO_UPLOADED' || tripAdvancedPlayerEvent.uploading_status === 'PARTIAL_VIDEO')) || state.showAdvancedPlayer)
				&& (
					<AdvancedPlayer
						event={state.selectedEvent || tripAdvancedPlayerEvent}
						onHide={onCloseEventVideoAll}
						openShareEvent={openShareEvent}
						onFlagEvent={onFlagEvent}
						isFlagged={(state.selectedEvent && state.selectedEvent.flagged) || (tripAdvancedPlayerEvent && tripAdvancedPlayerEvent.flagged)}
						openEventNote={openEventNote}
						note={(state.selectedEvent && state.selectedEvent.event_notes) || (tripAdvancedPlayerEvent && tripAdvancedPlayerEvent.event_notes)}
						updateDriver={updateDriver}
					/>
				)}

			{(!_.isEmpty(tripAdvancedPlayerEvent) && (tripAdvancedPlayerEvent.uploading_status !== 'VIDEO_UPLOADED' || tripAdvancedPlayerEvent.uploading_status !== 'PARTIAL_VIDEO'))
				&& (
					<EventViewSnapshotModal
						event={tripAdvancedPlayerEvent}
						onHide={() => props.setTripAdvancedPlayerEvent(null)}
					/>
				)}

			{(!_.isEmpty(tripShowShareEvent) || state.showShareEvent)
				&& (
					<EventShareModal
						event={state.selectedEvent || tripShowShareEvent}
						onHide={onCloseShareEvent}
					/>
				)}

			{state.showEventNote &&
				<EventNoteModal
					show={state.showEventNote}
					event={state.selectedEvent || tripAdvancedPlayerEvent}
					onHide={() => setState({ ...state, showEventNote: false })}
					company_name={props.company.company.name || user.company_name}
					partner_name={props.company.company.partner || user.partner_company_name}
					onSave={(eventNoteData) => onSaveEventNote(eventNoteData)}
				/>
			}
			{/* FWSD-7380 */}
			<NewMapFeedback />
		</div>
	)
}

const mapStateToProps = ({ user, company, tripreplay, dashboardData, partnerList }) => ({
	user,
	company,
	tripreplay,
	showTripsHistory: dashboardData.showTripsHistory,
	tripsGPS: dashboardData.tripsGPS,
	selectedTrip: dashboardData.selectedTrip,
	tripTimelineTimestamp: dashboardData.tripTimelineTimestamp,
	tripAdvancedPlayerEvent: dashboardData.tripAdvancedPlayerEvent,
	tripShowShareEvent: dashboardData.tripShowShareEvent,
	showSnapRoad: dashboardData.showSnapRoad,
	dashboardRedirect: dashboardData.dashboardRedirect,
	deviceTrips: dashboardData.deviceTrips,
	sideMenuOpen: dashboardData.sideMenuOpen,
	companiesCollection: partnerList.company_collection,
});

const mapDispatchToProps = dispatch => ({
	// updateTripreplay: (tripreplay) => {
	// 	dispatch({ type: 'GET_TRIPREPLAY_SUCCESS', payload: tripreplay });
	// },
	setTripAdvancedPlayerEvent: (state) => {
		dispatch({ type: 'SET_TRIP_ADVANCED_PLAYER_EVENT', payload: state })
	},
	setTripShowShareEvent: (state) => {
		dispatch({ type: 'SET_TRIP_SHOW_SHARE_EVENT', payload: state })
	},
	setTripsGPSSnapRoad: (state) => {
		dispatch({ type: 'SET_TRIPS_GPS_SNAP_ROAD', payload: state })
	},
	setShowSnapRoad: (state) => {
		dispatch({ type: 'SET_SHOW_SNAP_ROAD', payload: state })
	},
	setShowTripsHistory: (state) => {
		dispatch({ type: 'SET_SHOW_TRIP_HISTORY', payload: state })
	},
	addTripsGPSPolygonPoint: (state) => {
		dispatch({ type: 'ADD_TRIPS_GPS_POLYGON_POINT', payload: state })
	},
	setSelectedTrip: (state) => {
		dispatch({ type: 'SET_SELECTED_TRIP', payload: state })
	},
	setDeviceTrips: (arr) => {
		dispatch({ type: 'SET_DEVICE_TRIPS', payload: arr })
	},
	toggleLoader: (show) => {
		dispatch({ type: 'TOGGLE_LOADER', payload: show });
	},
	updateSideMenuOpen: (user) => {
		dispatch({ type: 'SET_SIDE_MENU_OPEN', payload: user });
	},
	setDashboardRedirect: (state) => {
		dispatch({ type: 'SET_DASHBOARD_REDIRECT', payload: state })
	},
})

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
